export default __webpack_public_path__ + "static/media/polygon-add.a0d1f4fe.svg";